import { SpaceNotificationPreference } from '@tribeplatform/gql-client/types'
import { I18nShape } from '@tribeplatform/react-components/i18n'

type NotificationOptionDescriptor = {
  value: SpaceNotificationPreference
  label: string
  description: string
}

export const MemberNotificationSettingOptions: (
  intl: I18nShape,
) => NotificationOptionDescriptor[] = intl => [
  {
    value: SpaceNotificationPreference.ALL,
    label: intl.$t({
      defaultMessage: 'All activity (new posts & replies)',
      id: 'Notification.AllActivity',
    }),
    description: intl.$t({
      defaultMessage: 'Notify me about new posts and replies in this {SPACE}',
      id: 'Notification.Preference.Member.Option.AllActivities.Description',
    }),
  },
  {
    value: SpaceNotificationPreference.NEW_POST,
    label: intl.$t({
      defaultMessage: 'New posts',
      id: 'Generics.NewPosts',
    }),
    description: intl.$t({
      defaultMessage: 'Notify me about new posts in this {SPACE}',
      id: 'Notification.Preference.Member.Option.NewPosts.Description',
    }),
  },
  {
    value: SpaceNotificationPreference.NONE,
    label: intl.$t({
      defaultMessage: 'Posts of Interest',
      id: 'Notification.PostsOfInterest',
    }),
    description: intl.$t({
      defaultMessage:
        'Notify me about new comments and reactions to my posts, and the posts I previously commented on',
      id: 'Notification.PostsOfInterest.Description',
    }),
  },
]

export const SpaceDefaultNotificationSettingOptions: (
  intl: I18nShape,
) => NotificationOptionDescriptor[] = intl => [
  {
    value: SpaceNotificationPreference.ALL,
    label: intl.$t({
      defaultMessage: 'All activity (new posts & replies)',
      id: 'Notification.AllActivity',
    }),
    description: intl.$t({
      defaultMessage: 'Notify me about new posts and replies',
      id: 'Notification.Preference.Default.Option.AllActivities.Description',
    }),
  },
  {
    value: SpaceNotificationPreference.NEW_POST,
    label: intl.$t({
      defaultMessage: 'New posts',
      id: 'Generics.NewPosts',
    }),
    description: intl.$t({
      defaultMessage: 'Notify me about new posts only',
      id: 'Notification.Preference.Default.Option.NewPosts.Description',
    }),
  },
  {
    value: SpaceNotificationPreference.NONE,
    label: intl.$t({
      defaultMessage: 'Posts of Interest',
      id: 'Notification.PostsOfInterest',
    }),
    description: intl.$t({
      defaultMessage:
        'Notify me about new comments and reactions to my posts, and the posts I previously commented on',
      id: 'Notification.PostsOfInterest.Description',
    }),
  },
]
